import React from 'react';
import { Linkedin, Share2 } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { trackEvent } from '../lib/analytics';

const SHARE_TEXT = 'Conocé la Unión Industrial Quilmes: asesoramiento, capacitación y networking para empresas industriales.';

export const ShareButtons = ({ dark = false }) => {
  const url = typeof window !== 'undefined' ? window.location.origin : 'https://uiquilmes.org';
  const whatsapp = `https://wa.me/?text=${encodeURIComponent(`${SHARE_TEXT} ${url}`)}`;
  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
  const canNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  const btn = dark
    ? 'bg-gray-800 hover:bg-blue-600 text-white'
    : 'bg-blue-50 hover:bg-blue-600 text-blue-700 hover:text-white border border-blue-100';

  const share = (method) => trackEvent('share', { method, content_type: 'landing' });

  const nativeShare = async () => {
    share('native');
    try {
      await navigator.share({ title: 'Unión Industrial Quilmes', text: SHARE_TEXT, url });
    } catch (_) {}
  };

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <a
        data-testid="share-whatsapp"
        href={whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Compartir por WhatsApp"
        onClick={() => share('whatsapp')}
        className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${btn}`}
      >
        <WhatsAppIcon className="w-5 h-5" />
      </a>
      <a
        data-testid="share-linkedin"
        href={linkedin}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Compartir en LinkedIn"
        onClick={() => share('linkedin')}
        className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${btn}`}
      >
        <Linkedin className="w-5 h-5" />
      </a>
      {canNativeShare && (
        <button
          data-testid="share-native"
          type="button"
          aria-label="Compartir"
          onClick={nativeShare}
          className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${btn}`}
        >
          <Share2 className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};
